import { Component, OnInit, ViewChild } from '@angular/core';
import { ContratoService } from 'src/app/pages/services/contratos/contrato.service';
import { GenerarAnexoService } from 'src/app/pages/services/PDF-GENERADOR/anexos/generar-anexo.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import saveAs from 'file-saver';
import { MatStepper } from '@angular/material/stepper';
import { contratosPorVencerTotal } from '../../../../shared/models/home-contratoPorVencer.interface';
import { TrabajadoresService } from '../../../services/trabajadores/trabajadores.service';
import { SucursalService } from 'src/app/pages/services/sucursales.service';
import { CiudadService } from 'src/app/pages/services/ciudades.service';
import { clausulas, valores } from '../generar-anexo-contrato/datos'

@Component({
  selector: 'app-generar-anexos-masivos',
  templateUrl: './generar-anexos-masivos.component.html',
  styleUrls: ['./generar-anexos-masivos.component.css']
})
export class GenerarAnexosMasivosComponent implements OnInit {
  displayedColumns: string[] = ['select', 'nombreTrabajador', 'empresa', 'cargo', 'fechaTermino', 'diffDays', 'tipo_contrato'];
  dataSource = new MatTableDataSource<any>();
  selectedRows = new Set<any>();
  loading: boolean = false;
  progress: number = 0;
  anexosContratos: contratosPorVencerTotal[] = [];
  contratosPorVencer: contratosPorVencerTotal[] = [];
  trabajadores: [];
  countContratos: number = 0;
  fechaFirmaAnexo: Date | null = null;
  CiudadSeleccionada: any = undefined;
  lista_ciudades: any;
  sucursales: any;
  mostrarfecha: Boolean = false
  texto: any;
  idClausula: number;
  numero_clausula: any;
  clausula_seleccionada: any;
  ejemplo: boolean = false;
  clausulas = clausulas;

  clausulaSeleccionada: any = null;
  textoClausula: string = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('stepper') stepper: MatStepper;

  constructor(private contratoService: ContratoService, private generarAnexoService: GenerarAnexoService, private trabajadorService: TrabajadoresService, private ciudadService: CiudadService,
    private sucursalService: SucursalService) { }

  ngOnInit(): void {
    this.traerContratosPorVencer();
  }

  traerContratosPorVencer() {
    this.loading = true;

    this.contratoService.verificarContratosPlazoFijo()
      .then((data: any[]) => {
        const hoy = new Date();

        const contratosTransformados: contratosPorVencerTotal[] = data.map(contrato => {
          const partesFecha = contrato.fechaTermino.split('-');
          const fechaConvertida = new Date(+partesFecha[2], +partesFecha[1] - 1, +partesFecha[0]);
          const fechaFinal = fechaConvertida.toISOString().split('T')[0];

          return {
            id: contrato.id,
            fk_trabajador: contrato.fk_trabajador,
            nombreTrabajador: contrato.nombreTrabajador,
            empresa: contrato.empresa,
            fechaTermino: fechaFinal,
            diffDays: contrato.diffDays,
            aviso: contrato.aviso ?? 0,
            tipo_contrato: contrato.tipo_contrato,
            cargo: contrato.cargo,
          };
        });

        this.contratosPorVencer = contratosTransformados.filter(contrato => contrato.tipo_contrato === 1);
        this.anexosContratos = contratosTransformados.filter(contrato => contrato.tipo_contrato === 2 || contrato.tipo_contrato === 3);
        this.countContratos = this.contratosPorVencer.length + this.anexosContratos.length + (this.trabajadores?.length || 0);

        this.dataSource.data = contratosTransformados;
      })
      .finally(() => {
        this.loading = false;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    this.ciudadService.traerCiudades().subscribe(
      (res) => {
        this.lista_ciudades = res.data;
      }
    );
    this.sucursalService.traerSucursales().subscribe(
      (res) => {
        this.sucursales = res.data;
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleSelection(row: any) {
    if (this.selectedRows.has(row)) {
      this.selectedRows.delete(row);
    } else {
      this.selectedRows.add(row);
    }
  }

  isAllSelected(): boolean {
    return this.selectedRows.size === this.dataSource.data.length;
  }

  toggleAllRows(isChecked: boolean) {
    if (isChecked) {
      this.dataSource.data.forEach(row => this.selectedRows.add(row));
    } else {
      this.selectedRows.clear();
    }
  }


  onClausulaSeleccionada() {
    if (this.clausulaSeleccionada) {
      this.textoClausula = this.clausulaSeleccionada.texto;
    }
  }


  async generarAnexosMasivos() {
    this.loading = true;
    this.progress = 0;
    const total = this.selectedRows.size;
    let count = 0;

    // Función para convertir un dataURL a Blob
    function dataURLtoBlob(dataURL: string): Blob {
      const arr = dataURL.split(',');
      const mimeMatch = arr[0].match(/:(.*?);/);
      if (!mimeMatch) {
        throw new Error("Formato de dataURL incorrecto");
      }
      const mime = mimeMatch[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }

    for (const trabajador of this.selectedRows) {
      try {
        const datosTrabajador = await this.trabajadorService.traerTrabajadorId(trabajador.fk_trabajador);
        const trabajadorCompleto = datosTrabajador.data[0];
        console.log("DATOS DEL TRABAJADOR: ", datosTrabajador.data[0])
        const datos = {
          Clausula: this.texto,
          Trabajador: trabajadorCompleto,
          NumeroClausula: this.numero_clausula,
          Ciudad: this.CiudadSeleccionada,
          clausulaSeleccionada: this.clausula_seleccionada.nombre,
          fechaFirmaAnexo: this.fechaFirmaAnexo
        };


        // Generamos el PDF y obtenemos el dataURL
        const pdfSrc = await this.generarAnexoService.generarPDF(datos);

        // Convertimos el dataURL a un Blob
        const pdfBlob = dataURLtoBlob(pdfSrc);

        // Descargamos el archivo utilizando FileSaver
        saveAs(pdfBlob, `anexo-${trabajadorCompleto.nombres}-${trabajadorCompleto.apellidos}.pdf`);

      } catch (error) {
        console.error(`Error generando anexo para ${trabajador.nombres} ${trabajador.apellidos}`, error);
      }

      count++;
      this.progress = Math.round((count / total) * 100);
    }

    this.loading = false;
    alert("Anexos generados exitosamente.");
  }





  MostrarEjemplo() {
    this.ejemplo = true;
  }

  ObtenerClausula(event?: any) {
    if (event && event.value) {
      this.clausula_seleccionada = event.value;
      // Puedes asignar el id si lo necesitas:
      this.idClausula = event.value.id;
    }
    switch (this.idClausula) {
      case 1:
        this.mostrarfecha = false;
        var temporal = valores[0].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 2:
        this.mostrarfecha = false;
        var temporal = valores[1].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 3:
        this.mostrarfecha = false;
        var temporal = valores[2].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 4:
        this.mostrarfecha = false;
        var temporal = valores[3].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 5:
        this.mostrarfecha = false;
        var temporal = valores[4].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 6:
        this.mostrarfecha = true
        this.texto = valores[5].valor
        break;
      case 7:
        this.mostrarfecha = false;
        var temporal = valores[6].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 8:
        this.mostrarfecha = false;
        var temporal = valores[7].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 9:
        this.mostrarfecha = false;
        var temporal = valores[8].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2]
        break;
      case 10:
        this.mostrarfecha = false;
        var temporal = valores[9].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2];
        break;
      case 12:
        this.mostrarfecha = false;
        console.log(valores);
        var temporal = valores[11].valor.split("%");
        this.texto = temporal[0] + this.numero_clausula + " " + temporal[2];
        break;
      default:
        this.mostrarfecha = false;
        break;
    }
  }


}
